import axiosInstance from "../configuration/api";

// service/otp.ts

export const sendOtpSignup = async (
  emailAddress: string,
  userName: string = "User"
) => {
  const response = await axiosInstance.post("/api/v1/otp/signup", {
    emailAddress,
    userName,
  });
  return response.data;
};

export const verifyOtp = async (emailAddress: string, otp: string) => {
  const response = await axiosInstance.post("/api/v1/otp/verify", {
    emailAddress,
    otp,
  });
  return response.data;
};

export const resendOtp = async (
  emailAddress: string,
  userName: string = "User"
) => {
  const response = await axiosInstance.post("/api/v1/otp/resend", {
    emailAddress,
    userName,
  });
  return response.data;
};
